// Footer Script mainly to get proper padding

(function($) {
	let arriveOptions = {
		onceOnly: true, // ensure that registered callbacks fire only once
		existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
	};

	let footer = '#theme-footer';
	let content = '#content';
	let $footerBanner = $(footer + ' .banner-container');

	function footerContentPadding() {
		if ( $(footer).length ) {
			let footerHeight = Math.ceil($(footer).outerHeight()) - 1;
			$(content).css('padding-bottom', `${footerHeight}px`);
		}
	}

	function scaleBanner() {
		let $container = $footerBanner;
		let $image = $container.find('.banner');

		if ( $image.length ) {
			scaleImageContainer($container, $image);
		}
	}

	function parallaxBanner() {
		let $container = $footerBanner;
		let $image = $container.find('.banner');
		let containerView = elementInView($container);
		if ( containerView === 'view' ) {
			parallaxImageContainer($container, $image);
		}
	}

	$(document).arrive(footer, arriveOptions, function() {
		footerContentPadding();
	});

	$(document).ready(function() {
		footerContentPadding();
	});

	$(window).on('load', function() {
		scaleBanner();
		parallaxBanner();
	});

	//# - On Resize
	$(window).on('resize', function() {
		scaleBanner();
		footerContentPadding();
	});

	$(window).on('scroll', function() {
		parallaxBanner();
	});
})(jQuery);
